/**
 * This file consolidates seo logic within website/shared
 *
 * suggestion: If we need to share this logic with other apps/projects we
 *             should move this logic to the @outschool/text package
 */
import { cleanUrlTerm } from "@outschool/routes";
import { compact, startCase, uniq } from "lodash";

import {
  DEFAULT_SUBJECTS,
  DEFAULT_SUBJECTS_LIST_VERSION
} from "./constants/subjects";
import { Subject } from "./types";

const synonymsForClasses = [
  "camp",
  "club",
  "lesson",
  "tutor",
  "workshop",
  "tutoring",
  "course",
  "courses",
  "taught",
  "curriculum"
];

const ageRelatedKeywords = [
  "grade",
  "high school",
  "kindergarten",
  "middle school"
];

export function containsAgeRelatedTerm(term: string) {
  return containsTerm(term, ageRelatedKeywords);
}

export function containsClassRelatedTerm(term: string) {
  return containsTerm(term, synonymsForClasses);
}

export function containsPluralTerm(term: string) {
  // check if term ends with an s
  if (term && term.match(/s$/gi)) {
    term = term.trim().toLowerCase();
    if (["is", "ss"].includes(term.substring(term.length - 2))) {
      return false;
    }
    return true;
  }

  return false;
}

export function isTermWithinSubjectList(
  term: string,
  version = DEFAULT_SUBJECTS_LIST_VERSION
): boolean {
  return fetchSubjects(version).includes(cleanUrlTerm(term));
}

export function fetchSubjects(
  version = DEFAULT_SUBJECTS_LIST_VERSION
): string[] {
  return cleanSubjectTerms(DEFAULT_SUBJECTS[version]);
}

export function niceSubjectTerm(subject: string): string {
  return startCase(cleanUrlTerm(subject)).replace("And", "&");
}

function cleanSubjectTerms(subjectList: Subject[]): string[] {
  return compact(
    uniq(
      subjectList.map((subject: Subject) => {
        return cleanUrlTerm(subject.slug);
      })
    )
  ).sort();
}

function containsTerm(term: string, termList: string[]) {
  return termList.some(listTerm => term.toLowerCase().includes(listTerm));
}

// note: no trailing slash for online classes but it is also a root url that can contain search query parameters
const allowedNoIndexPaths = [
  "/classes/",
  "/online-classes",
  "/teachers/",
  "/users/login"
];
export function shouldServeNoIndex({
  urlPath,
  hasSearchQuery
}: {
  urlPath: string;
  hasSearchQuery: boolean;
}): boolean {
  urlPath = urlPath.toLowerCase();

  // then check if the urlPath is allowed
  if (
    !urlPath ||
    !allowedNoIndexPaths.some((allowedPath: string) =>
      urlPath.startsWith(allowedPath)
    )
  ) {
    return false;
  }

  // if any search params are present then show noindex
  if (hasSearchQuery) {
    return true;
    // if /enroll is present within a class url
  } else if (urlPath.includes("/classes/") && urlPath.includes("/enroll")) {
    return true;
  }

  return false;
}
